var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardar24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.75C4.20507 2.75 2.75 4.20507 2.75 6V18C2.75 19.7949 4.20507 21.25 6 21.25H18C19.7949 21.25 21.25 19.7949 21.25 18V9.24264C21.25 8.6459 21.0129 8.07361 20.591 7.65165L16.3483 3.40901C15.9264 2.98705 15.3541 2.75 14.7574 2.75H6ZM1.25 6C1.25 3.37665 3.37665 1.25 6 1.25H14.7574C15.7519 1.25 16.7057 1.64509 17.409 2.34835L21.6516 6.59099C22.3549 7.29425 22.75 8.24808 22.75 9.24264V18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 15C5.25 13.4812 6.48122 12.25 8 12.25H16C17.5188 12.25 18.75 13.4812 18.75 15V22.75H5.25V15ZM8 13.75C7.30964 13.75 6.75 14.3096 6.75 15V21.25H17.25V15C17.25 14.3096 16.6904 13.75 16 13.75H8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 6C7.25 6.9665 8.0335 7.75 9 7.75H15C15.9665 7.75 16.75 6.9665 16.75 6V2H15.25V6C15.25 6.13807 15.1381 6.25 15 6.25H9C8.86193 6.25 8.75 6.13807 8.75 6V2H7.25V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardar24X24);
export default __webpack_public_path__ + "static/media/GUARDAR_24X24.e87b2402454dce2bb487aecbdd552ba3.svg";
export { ForwardRef as ReactComponent };